import { createContext, useContext, useEffect, useState, useCallback } from "react";
import apiClient, { setToken, clearToken, getToken } from "@/lib/apiClient";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, obj=authed

  const checkAuth = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      return;
    }
    try {
      const { data } = await apiClient.get("/auth/me");
      setUser(data);
    } catch {
      clearToken();
      setUser(null);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      // AuthCallback will handle session exchange
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const loginWithToken = (token, userObj) => {
    setToken(token);
    setUser(userObj);
  };

  const logout = async () => {
    try {
      await apiClient.post("/auth/logout");
    } catch (_) {}
    clearToken();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loginWithToken, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
